import React, { useEffect, useState } from "react";
import { Input } from "antd";
import "./index.css";

const AdminOrganizationSearch = ({ sendSearchValue }) => {
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    sendSearchValue(searchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <Input
      className="admin-organization-search-input"
      onChange={(e) => setSearchValue(e.target.value)}
      placeholder="Търсене"
    ></Input>
  );
};

export default AdminOrganizationSearch;
